import fb from "@/firebase/firebase"

const db = fb.firestore()

const dbs = {
    users: db.collection("users"),
    firms: db.collection("firms"),
    customers: db.collection("customers"),
    stripe_customers: db.collection('stripe_customers'),
    mail: db.collection('mail')
}

export { dbs, fb }
export default dbs